export default () => (
<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 2.98984L3.22114 5L8 1" stroke="#161B2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)